export enum UpgradeIds {
	__TODO__ = Number.MAX_SAFE_INTEGER,
	friendly_visits = 1,
	fruit_baskets = 2,
	quick_tool = 3,
	scout = 4,
	bow_saw = 5,
	stewardship = 6,
	log_driving = 7,
	horse_collar = 8,
	settlers = 9,
	farm_roads = 10,
	cartography = 11,
	tax_season = 12,
	pickaxe = 13,
	espionage = 14,
	scout_cavalry = 15,
	beasts_of_burden = 16,
	finger_on_the_pulse = 17,
	pro_explorer2 = 18,
	bellows = 19,
	dry_dock = 20,
	lazy_finger = 21,
	accounting = 22,
	efficient_storage = 23,
	hammer_and_tongs = 24,
	compass = 25,
	smelting = 26,
	haggling = 27,
	efficient_packaging = 28,
	fair_trade = 29,
	tax_collector = 30,
	reclamation = 31,
	butterfingers = 32,
	scout_cavalry2 = 33,
	premium_storage = 34,
	treasure_hunter = 35,
	tracking = 36,
	architecture = 37,
	inflation = 38,
	pro_explorer3 = 39,
	spyglass = 40,
	miners_guild = 41,
	inventory = 42,
	durable_nets = 43,
	scout_cavalry3 = 44,
	pro_explorer4 = 45,
	tents = 46,
	conscription = 47,
	gem_rush = 48,
	shaft_mining = 49,
	gold_rush = 50,
	craftsmanship = 51,
	grazing = 52,
	coast_patrol = 53,
	regent = 54,
	plough = 55,
	seafaring = 56,
	smooth_flour = 57,
	two_man_saw = 58,
	messenger = 59,
	wooden_wedges = 60,
	millers_guild = 61,
	highlanders = 62,
	forest_paths = 63,
	harbor_crane = 64,
	wheelbarrow = 65,
	farm_roads3 = 66,
	hoisting_winch = 67,
	pro_explorer1 = 68,
	royal_earnings = 69,
	reeve = 70,
	scribe = 71,
	road_toll = 72,
	accounting2 = 73,

	compass2 = 74,
	royal_advisor = 75,
	road_toll2 = 76,
	forestry = 77,
	multi_story_accomodation = 78,
	stewardship2 = 79,
	regent2 = 80,
	reforestation = 81,
	scout_cavalry4 = 82,
	pro_explorer5 = 83,
	multi_story_accomodation2 = 84,
	trade_cog = 85,
	wine_cellar = 86,
	conscription2 = 87,
	exotic_goods = 88,
	free_market = 89,
	ingots = 90,
	naval_trade = 91,
	stewardship3 = 92,
	regent3 = 93,
	snorkel = 94,
	mountain_lumberjacks = 95,
	efficient_storage2 = 96,
	scout2 = 97,
	beasts_of_burden2 = 98,
	farm_roads2 = 99,
	harpoon = 100,
	attic = 101,
	scout3 = 102,
	mountain_paths = 103,
	outskirts = 104,
	gold_panning = 105,

	embankment = 1001,
	max_offline_time = 1002,
	line_of_sight = 1003,
	mushroom = 1004,
	pirate_navigation = 1005,
	atol = 1006,
	crater = 1007,
	kraken = 1008,
	witch_lake = 1009,
	geyser = 1010,
}

export enum EventUpgradeIds {
	// CHRISTMAS
	ch_bow_saw = 2001,
	ch_two_man_saw = 2002,
	ch_wood_splitting = 2003,
	ch_wood_processing = 2004,
	ch_beasts_of_burden = 2005,
	ch_log_driving = 2006,
	ch_mountain_lumberjacks = 2007,
	ch_highlanders = 2008,
	ch_wood_carving = 2009,
	ch_trading = 2010,
	ch_foreman = 2011,
	// EASTER
	ea_egg_painting = 2101,
	ea_trained_decorators = 2102,
	ea_artistic_decorators = 2103,
	ea_easter_workshops = 2104,
	ea_small_surprise = 2105,
	ea_medium_surprise = 2106,
	ea_big_surprise = 2107,
	ea_giant_surprise = 2108,
	ea_golden_chance = 2109,
	ea_golden_jackpot = 2110,
	ea_golden_surprise = 2111,
	ea_golden_surprise2 = 2112,
	ea_golden_surprise3 = 2113,
	ea_easter_bunny = 2114,
	ea_legendary_easter_bunny = 2115,
	ea_egg_magnet = 2116,
	ea_trading = 2117,
	ea_foreman = 2118,
	ea_eventium_income = 2119,
	ea_eventium_income2 = 2120,
	ea_eventium_income3 = 2121,
	ea_eventium_income4 = 2122,
	ea_eventium_income5 = 2123,
	ea_eastertide_special1 = 2124,
	ea_eastertide_special2 = 2125,
	ea_eastertide_special4 = 2126,
	// FISHING
	fi_trained_fishermen = 2201,
	fi_experienced_fishermen = 2202,
	fi_professional_fishermen = 2203,
	fi_elite_fishermen = 2204,
	fi_sail = 2205,
	fi_durable_materials = 2206,
	fi_fish_feeding = 2207,
	fi_fish_market = 2208,
	fi_trading = 2209,
	fi_foreman = 2210,
	fi_eventium_income = 2211,
	fi_eventium_income2 = 2212,
	// FIREFEST
	ff_maple_wood = 2301,
	ff_beech_wood = 2302,
	ff_black_locust_wood = 2303,
	ff_oak_wood = 2304,
	ff_cleft_wood = 2305,
	ff_seasoned_wood = 2306,
	ff_apple_wood = 2307,
	ff_cherry_wood = 2308,
	ff_birch_wood = 2309,
	ff_hickory_wood = 2310,
	ff_town_celebrations = 2311,
	ff_carbon_tax = 2312,
	ff_kindling_of_passion = 2313,
	ff_kindling_of_hope = 2314,
	ff_trading = 2315,
	ff_foreman = 2316,
	ff_special_01 = 2317,
	ff_special_02 = 2318,
	ff_special_03 = 2319,
	ff_special_04 = 2320,
	ff_bundle_1 = 2321,
	ff_bundle_2 = 2322,
	ff_bundle_3 = 2323,
	ff_bundle_4 = 2324,
	//SOLAR FAIR
	sf_good_harvest = 2401,
	sf_great_harvest = 2402,
	sf_bountiful_harvest = 2403,
	sf_historic_harvest = 2404,
	sf_skilled_gatherers = 2405,
	sf_adept_hunters = 2406,
	sf_experienced_farmers = 2407,
	sf_master_bakers = 2408,
	sf_free_market_economy = 2409,
	sf_booming_economy = 2410,
	sf_peddler = 2411,
	sf_special_01 = 2412,
	sf_special_02 = 2413,
	sf_special_03 = 2414,
	sf_bundle_1 = 2415,
	sf_bundle_2 = 2416,
	sf_bundle_3 = 2417,
	//HUNTING
	hu_duck_season = 2501,
	hu_fox_season = 2502,
	hu_rabbit_season = 2503,
	hu_deer_season = 2504,
	hu_boar_season = 2505,
	hu_wolf_season = 2506,
	hu_red_deer_season = 2507,
	hu_bear_season = 2508,
	hu_tracking = 2509,
	hu_falconry = 2510,
	hu_mountaineering = 2511,
	hu_trophy_exhibits = 2512,
	hu_trading = 2513,
	hu_foreman = 2514,
	hu_bow_1 = 2515,
	hu_bow_3 = 2516,
	hu_horse_2 = 2517,
	hu_horse_4 = 2518,
	// HALLOWEEN
	ha_pumpkin_carving = 2601,
	ha_trained_carvers = 2602,
	ha_artistic_carvers = 2603,
	ha_halloween_workshops = 2604,
	ha_small_pumpkin = 2605,
	ha_medium_pumpkin = 2606,
	ha_large_pumpkin = 2607,
	ha_giant_pumpkin = 2608,
	ha_will_o_the_wisp = 2609,
	ha_ignis_fatuus = 2610,
	ha_mischievous_ghost = 2611,
	ha_troubled_ghost = 2612,
	ha_evil_ghost = 2613,
	ha_pumpkin_seeds = 2614,
	ha_pumpkin_patch = 2615,
	ha_pumpkin_magnet = 2616,
	ha_trading = 2617,
	ha_foreman = 2618,
	ha_special1 = 2619,
	ha_special2 = 2620,
	ha_special4 = 2621,
	ha_fire1 = 2622,
	ha_fire2 = 2623,
	ha_fire3 = 2624,
	ha_fire4 = 2625,
	// PIRATES
	pi_coin_minting = 2701,
	pi_small_mint = 2702,
	pi_medium_mint = 2703,
	pi_large_mint = 2704,
	pi_town_maps = 2705,
	pi_terrain_maps = 2706,
	pi_detailed_maps = 2707,
	pi_atlas = 2708,
	pi_treasure_hunters = 2709,
	pi_experienced_treasure_hunters = 2710,
	pi_buried_treasure = 2711,
	pi_lost_treasure = 2712,
	pi_cursed_treasure = 2713,
	pi_pirate_code = 2714,
	pi_rum_barrels = 2715,
	pi_magnetic = 2716,
	pi_foreman = 2717,
	pi_pack1 = 2718,
	pi_pack2 = 2719,
	pi_pack4 = 2720,
	pi_bundle1 = 2721,
	pi_bundle2 = 2722,
	pi_bundle3 = 2723,
	pi_bundle4 = 2724,
}
